import { createApp } from "vue";
import store from "./store/store";
import ParkMap from "./ParkMap.vue"

if (document.querySelector('#park_map')) {
  const app = createApp(ParkMap)
  app.use(store);
  app.mount('#park_map');
}
